import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 1 }

import stubs from '@/init';
import {
  timeFormat,
  durationBetween,
} from '@ldos/shared-common/src/util/formatUtils';
import { ElTableColumn } from 'element-plus';
import { Dictionary } from 'lodash';
import { computed, useAttrs, useSlots } from 'vue';
import { findPath } from '@ldos/shared-common/src/util/utilsHandle';


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
  },
  prop: {
    type: String,
    default: '',
  },
  pocketName: {
    type: String,
    default: '',
  },
  formatter: {
    type: Function,
  },
},
  setup(__props) {

const props = __props



const slots = useSlots();

const attrs = useAttrs();
const alterType = computed(() =>
  ['selection', 'index', 'expand'].includes(props.type || '')
    ? props.type
    : undefined
);
const timeHandler = (row: Dictionary<any>) =>
  timeFormat(findPath(row, props.prop));
const booleanHandler = (row: Dictionary<any>) =>
  findPath(row, props.prop) ? '是' : '否';
const numberHandler = (row: Dictionary<any>) =>
  findPath(row, props.prop).toString();
const pocketHandler = (row: Dictionary<any>) =>
  stubs.pockets.obtainPocketLabel(
    props.pocketName,
    findPath(row, props.prop)
  ) || '-';
const durationHandler = (row: Dictionary<any>) => {
  const [key1, key2] = props.prop.split('->');
  return durationBetween(row[key1], row[key2] || 0);
};
const defaultHandler = (row: Dictionary<any>) => findPath(row, props.prop);
const handleRow = computed(() => {
  let handler = (row: any) => {
    if (
      props.prop.toLowerCase().includes('time') &&
      typeof findPath(row, props.prop) === 'number'
    ) {
      return timeHandler(row);
    } else if (typeof findPath(row, props.prop) === 'number') {
      return numberHandler(row);
    } else if (typeof findPath(row, props.prop) === 'boolean') {
      return booleanHandler(row);
    } else if (props.pocketName) {
      return pocketHandler(row);
    } else if (
      props.prop.includes('->') &&
      props.prop.toLowerCase().includes('time')
    ) {
      return durationHandler(row);
    } else {
      return defaultHandler(row);
    }
  };
  switch (props.type) {
    case 'time':
      handler = timeHandler;
      break;
    case 'pocket':
      handler = pocketHandler;
      break;
    case 'boolean':
      handler = booleanHandler;
      break;
    case 'duration':
      handler = durationHandler;
      break;
    case 'default':
    default:
      break;
  }
  return props.formatter || handler;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElTableColumn), _mergeProps({ type: _unref(alterType) }, { align: 'center', ..._unref(attrs) }), _createSlots({ _: 2 }, [
    (_unref(slots).default || !_unref(alterType))
      ? {
          name: "default",
          fn: _withCtx((slotScope) => [
            (_unref(slots).default)
              ? _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: 0 }, slotScope)))
              : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(handleRow)(slotScope.row)), 1))
          ])
        }
      : undefined
  ]), 1040, ["type"]))
}
}

})